import { create } from 'zustand';
import type { AdminUserInfo } from '../types/auth';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  adminUser: AdminUserInfo | null;
  tempToken: string | null;
  requires2fa: boolean;

  setTokens: (access: string, refresh: string) => void;
  setUser: (user: AdminUserInfo) => void;
  setTempToken: (token: string) => void;
  set2faRequired: (required: boolean) => void;
  clear: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: localStorage.getItem('admin_access_token'),
  refreshToken: localStorage.getItem('admin_refresh_token'),
  adminUser: (() => {
    try {
      const stored = localStorage.getItem('admin_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })(),
  tempToken: null,
  requires2fa: false,

  setTokens: (access, refresh) => {
    localStorage.setItem('admin_access_token', access);
    localStorage.setItem('admin_refresh_token', refresh);
    set({ accessToken: access, refreshToken: refresh, tempToken: null, requires2fa: false });
  },

  setUser: (user) => {
    localStorage.setItem('admin_user', JSON.stringify(user));
    set({ adminUser: user });
  },

  setTempToken: (token) => set({ tempToken: token, requires2fa: true }),

  set2faRequired: (required) => set({ requires2fa: required }),

  clear: () => {
    localStorage.removeItem('admin_access_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    set({ accessToken: null, refreshToken: null, adminUser: null, tempToken: null, requires2fa: false });
  },

  isAuthenticated: () => !!get().accessToken,
}));
